import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        background: 'linear-gradient(135deg, #e3f2fd 0%, #f4f6f9 55%)',
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 420 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, justifyContent: 'center' }}>
          <GroupsOutlinedIcon color="primary" fontSize="large" />
          <Typography variant="h5" color="primary">OrkaCrew</Typography>
        </Box>
        <Card>
          <CardContent sx={{ p: { xs: 2.5, sm: 4 } }}>
            <Typography variant="h5" component="h1">{title}</Typography>
            {subtitle && <Typography color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>{subtitle}</Typography>}
            {children}
          </CardContent>
        </Card>
        {footer && (
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 2 }}>
            {footer}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
